import { defineRecipe } from "@chakra-ui/react";

export const buttonRecipe = defineRecipe({
  base: {
    fontFamily: "body",
  },
  variants: {
    visual: {
      white: {
        bg: "white",
        color: "mainText.200",
        transition: "all .3s",
        _hover: {
          background: "blackAlpha.200",
          transition: "all .3s",
        },
        _active: {
          background: "blackAlpha.700",
          transition: "all .3s",
        },
      },
      solidYellow: {
        bg: "yellowC.200",
        color: "mainText.200",
        transition: "all .3s",
        _hover: {
          background: "yellowC.300",
          transition: "all .3s",
        },
        _active: {
          background: "yellowC.200",
          transition: "all .3s",
        },
      },
      solidPurple: {
        background: "purpleC.200",
        color: "whiteAlfa.100",
        transition: "all .3s",
        _hover: {
          background: "purpleC.300",
          transition: "all .3s",
        },
        _active: {
          background: "purpleC.200",
          transition: "all .3s",
        },
      },
      solidBlack: {
        background: "blackAlpha.700",
        color: "yellowC.200",
        transition: "all .3s",
        _hover: {
          background: "blackAlpha.900",
          transition: "all .3s",
        },
        _active: {
          background: "blackAlpha.700",
          transition: "all .3s",
        },
      },
      outline: { borderWidth: "1px", borderColor: "red.200" },
      transparent: {
        background: "transparent",
        _hover: {
          background: "blackAlpha.200",
        },
      },
    },
    size: {
      sm: {
        width: "80px",
        height: "48px",
        fontSize: "20px",
      },
      sm2: {
        width: "80px",
        height: "48px",
        fontSize: "16px",
      },
      md: {
        width: "100px",
        height: "48px",
        fontSize: "16px",
      },
      lg: {
        width: "133px",
        height: "48px",
        fontSize: "18px",
      },
      xl: {
        width: "150px",
        height: "48px",
        fontSize: "18px",
      },
      xl2: {
        width: "200px",
        height: "48px",
        fontSize: "18px",
      },
      xxl: {
        width: "200px",
        height: "70px",
        fontSize: "24px",
        fontWeight: "700",
      },
      smMobileIconButton: {
        width: "40px",
        height: "40px",
        fontSize: "20px",
      },
      smMobileMenuButton: {
        width: "40px",
        height: "40px",
        fontSize: "20px",
      },
    },
  },
  defaultVariants: {
    visual: "white",
    size: "lg",
  },
});
